export {IParallel} from "../common/parallel";
export {ITaskDefinition} from "../common/task/task-definition";
export {ITask} from "../common/task/task";
export {IFunctionDefinition} from "../common/function/function-defintion";
export {IFunctionId, isFunctionId} from "../common/function/function-id";
export {FunctionCall} from "../common/function/function-call";
export {ISerializedFunctionCall, isSerializedFunctionCall} from "../common/function/serialized-function-call";
export {FunctionCallSerializer} from "../common/function/function-call-serializer";
export {IThreadPool} from "../common/thread-pool/thread-pool";
export * from "../common/parallel/index";



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/api/shared.ts